// Meta Pixel - ID: 782547894469810
// Runs immediately on module load for earliest possible execution
const PIXEL_ID = '782547894469810'

// Inject Facebook Pixel base code immediately
;(function () {
  const script = document.createElement('script')
  script.textContent =
    '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?' +
    'n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;' +
    'n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;' +
    't.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,' +
    'document,"script","https://connect.facebook.net/en_US/fbevents.js");' +
    'fbq("init","' +
    PIXEL_ID +
    '");' +
    'fbq("track","PageView");'
  document.head.appendChild(script)
})()

export function trackAddToCart(params?: Record<string, unknown>): void {
  const script = document.createElement('script')
  script.textContent =
    'if(window.fbq){fbq("track","AddToCart",' +
    JSON.stringify(params || {}) +
    ');}'
  document.head.appendChild(script)
}
